import { render, staticRenderFns } from "./MarketCatalogFilters.vue?vue&type=template&id=68fc0c52&scoped=true&"
import script from "./MarketCatalogFilters.vue?vue&type=script&lang=js&"
export * from "./MarketCatalogFilters.vue?vue&type=script&lang=js&"
import style0 from "./MarketCatalogFilters.vue?vue&type=style&index=0&id=68fc0c52&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc0c52",
  null
  
)

export default component.exports